module.exports = __webpack_public_path__ + "img/notice_任务逾期_new.jpg";